import { render } from "./App.vue?vue&type=template&id=58e00afc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=58e00afc&lang=scss"
script.render = render

export default script